import { ListParams, ListResponse, objectDevice } from './../models/common';
import axiosClient from './axiosClient';

const urlApi = '/api/v1';
export const commonApi = {
  setValueOfProperties(param: ListParams): Promise<any> {
    const url = `${urlApi}/${param.key}?inverter_id=${param.id}`;
    return axiosClient.post(url, param.newList);
  },
  fetchDeviceProfile(param: ListParams): Promise<ListResponse<objectDevice>> {
    const url = `${urlApi}/device-profile?text_search=${param.text_search}&page_size=${param._limit}&page=${param._page}`;
    return axiosClient.get(url);
  },
};
